<template>
  <el-dialog
    :title="titles"
    :visible.sync="showBox"
    width="600px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    @open="clear"
  >
    <el-row>
      <el-col :span="12" style="border-right: 1px solid #D8DCE1;">
        <el-card class="box-card" :body-style="{ height: '460px', overflow: 'auto' , padding: '12px 24px' }" shadow="never">
        <div style="">
          <el-input
            clearable
            class="filter-input"
            placeholder="搜索员工"
            v-model="filterText"
            @input="dfhuh"
            size="small"
          >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
          </div>
          <div v-if="treeData01.length > 0 && treeData02.length === 0">
          <el-tree
              ref="tree"
              id="fixtree"
              :props="defaultProps"
              node-key="value"
              :check-on-click-node="true"
              :load="loadNode"
              :filter-node-method="filterNode"
              :check-strictly="true"
              :default-checked-keys="peoples"
              lazy
              show-checkbox
              @check-change="getChecked">
              <span class="custom-tree-node" slot-scope="{ data, node}">
                  <span v-if="data.isDepartment === false">
                    <img class="organization-img imgleft" src="../../../../assets/images/zuzhi.png" style="width:14px;height:14px;" alt="">
                    <span v-if="data.is_show === true" style="color: #9D9D9D;margin-left: 3px;">{{ data.label }}</span>
                    <span v-if="data.is_show === false">{{ data.label }}</span>
                  </span>
                  <span v-if="data.isDepartment === true">
                    <img v-if="data.label" class="organization-img" src="../../../../assets/images/user.png" style="width:14px;height:14px;" alt="">
                    <span style="margin-left: 3px;">{{ data.label }}</span>
                    <span
                      v-if="node.checked && data.label"
                      style="margin-left: 10px;"
                      class="el-icon-check"
                    ></span>
                  </span>
                </span>
            </el-tree>
            </div>
            <ul class="infinite-lists" v-if="treeData02.length > 0" styel="z-index: 999;">
              <li v-for="(item, index) in treeData02" :key="index" @click="getChecked(item)" style="text-align:left;margin-top:10px;">
                  <img class="organization-img" src="../../../../assets/images/user.png" style="width:14px;height:14px;" alt="">
                  <span style="margin-left:15px;">{{ item.label }} - {{ item.department_name}}</span>
              </li>
            </ul>
        </el-card>
      </el-col>
      <el-col :span="12" style="border-right: 1px solid #D8DCE1;">
        <el-card class="box-card" :body-style="{ height: '230px', overflow: 'auto', padding: '12px 24px' }">
          <div>已选择的员工/部门</div>
          <ul class="infinite-list" v-if="showList.length">
            <li class="cich fsdfs" v-for="(item,index) in showList" :key="item.id">
              <img class="organization-img" src="../../../../../src/assets/images/user.png" style="width:14px;height:14px;" alt="">
              <div :class="item.name.length <= 20 ? 'wqeq' : 'gfdgd'">{{ item.name }}</div>
              <div class="uiwe">
                <i class="el-icon-close " @click="showListClose(item, index, item.type)"></i>
              </div>
            </li>
          </ul>
        </el-card>
      </el-col>
      <!--<el-col :span="12" style="border-right: 1px solid #D8DCE1;">
        <el-card class="box-card" :body-style="{ height: '230px', overflow: 'auto', padding: '12px 24px' }">
          <div>已选择的部门</div>
          <ul class="infinite-list" v-if="checkedDepartment.length">
            <li class="cich fsdfs" v-for="(item,index) in checkedDepartment" :key="item.id">
              <img class="organization-img" src="../../../../../src/assets/images/user.png" style="width:14px;height:14px;" alt="">
              <div :class="item.name.length <= 20 ? 'wqeq' : 'gfdgd'">{{ item.name }}</div>
              <div class="uiwe">
                <i class="el-icon-close " @click="departmentClose(item, index)"></i>
              </div>
            </li>
          </ul>
        </el-card>
      </el-col>-->
    </el-row>
    <span slot="footer" class="dialog-footer">
      <div></div>
      <div>
        <el-button type="info" plain @click="close">取消</el-button>
        <el-button style="width: 72px;" type="primary" :disabled="disabled" @click="selectConfirm()">
          确定
        </el-button>
      </div>
    </span>
  </el-dialog>
</template>
<script>
  import { index } from './selectDepPers.js'
  export default { name: 'selectDepPers', mixins: [index] }
</script>
<style lang="scss" scoped>
  @import "./selectDepPers.scss";
</style>
